import { useQuery } from '@tanstack/react-query'

import { requestBusinessObjects } from 'shared/services'
import { useJWTToken } from 'App/Auth'

const getLogger = ({ queryKey: [
    _key,
    {
        qrCode,
        token,
    },
] }) => {
    const escapedQrCode = encodeURIComponent(qrCode)

    return requestBusinessObjects({
        method: 'GET',
        url: `skycenter/logger/loggerqrcode/${escapedQrCode}`,
        token,
    })
        .then((data) => {
            return data.data
        })
}

function useGetLoggerByQRCode(qrCode, enabled) {
    const token = useJWTToken()

    return useQuery({
        queryKey: [
            'getLoggerByQRCode',
            {
                qrCode,
                token,
            },
        ],
        queryFn: getLogger,
        enabled: Boolean(qrCode) && enabled,
        refetchOnWindowFocus: false,
        retry: false,
        staleTime: 1000,
    })
}

export default useGetLoggerByQRCode
